export const MARK_AS_READ = 'MARK_AS_READ';
export const SAVE_COUNT = 'SAVE_COUNT';

export const markAsReadAction = data => ({
  type: MARK_AS_READ,
  payload: {
    data,
  },
});
